import GLPostsView from './GLPosts'
export default GLPostsView
